<template>
  <v-container>
    <v-card class="pa-2">
      <div v-if="searching">
        <p class="text-center mt-5">
          <v-icon>fas fa-atom fa-spin</v-icon> Carregando agentes ...
        </p>
      </div>
      <div class="pa-2">
        <template v-if="searchResult && searchResult.data && searchResult.data">
          <v-card>
            <v-card-title>
              Agentes
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searchResults"
                append-icon="fas fa-search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              style="cursor: pointer;"
              :headers="headers"
              :items="searchResult.data"
              class="elevation-1"
              :search="searchResults"
              @click:row="openItem"
            >
              <template v-slot:item.status="{ item }">
                {{statusLabel[item.status]}}
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn icon @click.stop="deleteAgent(item)" :disabled="searching"
                  ><v-icon color="red">fas fa-times</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </template>
      </div>
      <v-dialog v-model="dialog" width="700">
        <v-card v-if="selectedProd">
          <v-card-title class="headline" primary-title>
            Editar: {{ selectedProd.name }}
          </v-card-title>
          <v-card-text class="text-center">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  :disabled="searching"
                  label="Nome"
                  v-model="selectedProd.name"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :disabled="searching"
                  type="text"
                  label="Chave unica do agente"
                  v-model="selectedProd.key"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  :disabled="searching"
                  type="number"
                  label="Quantidade de tarefas simultaneas"
                  v-model="selectedProd.job_count"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  :disabled="searching"
                  type="number"
                  label="Limite de tempo da tarefa (recomendado 30 minutos no máximo)"
                  v-model="selectedProd.job_timeout"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-select
                  v-model="selectedProd.status"
                  :items="statuses"
                  item-value="status"
                  item-text="name"
                  label="Status do agente"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="searching" color="success" @click="editOrSave()"
              ><v-icon>fas fa-save</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn
        @click="fetchSearch()"
        class="mr-3"
        style="margin-bottom: 50px"
        :disabled="searching"
        absolute
        fab
        bottom
        fixed
        right
        color="warning"
      >
        <v-icon>fas fa-sync</v-icon>
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'amz',
  components: {},
  data() {
    return {
      selectedProd: null,
      dialog: false,
      search: null,
      ASIN: null,
      limit: 10,
      prime: false,
      searchResults: null,
      searchResult: null,
      searching: false,
      statuses: [
        { status: 0, name: 'DESATIVADO' },
        { status: 1, name: 'ATIVO' },
      ],
      statusLabel: {
        0: 'DESATIVADO',
        1: 'ATIVO'
      },
      headers: [
        { text: 'Nome', value: 'name' },
        { text: 'Chave', value: 'key' },
        { text: 'Tarefas Simultaneas', value: 'job_count' },
        { text: 'Timeout', value: 'job_timeout' },
        { text: 'Status', value: 'status' },
        { text: 'Remover', value: 'action' }
      ]
    }
  },
  mounted() {
    this.fetchSearch()
  },
  created() {},
  methods: {
    deleteAgent(agent) {
      var vm = this
      if (confirm('Deseja realmente excluir a tarefa?')) {
        vm.searching = true
        vm.$API
          .Request('delete', `agents/delete/${agent.id}`)
          .then(() => {
            vm.$snotify.success('Agente removido com sucesso')
            console.log('Agente removido com sucesso')
            for (let ixsr = 0; ixsr < vm.searchResult.data.length; ixsr++) {
              const _agent = vm.searchResult.data[ixsr]
              if (_agent.id === agent.id) {
                vm.searchResult.data.splice(ixsr, 1)
                break
              }
            }
            vm.searchResult.data.push({})
            vm.searchResult.data.pop()
            vm.searching = false
          })
          .catch(error => {
            vm.searching = false
            console.debug(error)
            vm.$snotify.error(error.message)
          })
      }
    },
    copyTestingCode(_elementID) {
      var vm = this
      let testingCodeToCopy = document.querySelector(`#${_elementID}`)
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()

      try {
        if (document.execCommand('copy')) {
          vm.$snotify.success(`Texto copiado para a área de transferência`)
        } else {
          throw new Error(
            'Não foi possível copiar o texto para área de transferência. Copie manualmente'
          )
        }
      } catch (_err) {
        vm.$snotify.error(`Oops... ${_err.message}`)
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    fetchSearch() {
      var vm = this
      vm.searching = true
      vm.$API
        .Request('post', `agents/list`)
        .then(result => {
          console.debug(result)
          vm.searchResult = result
          vm.searching = false
        })
        .catch(error => {
          vm.searching = false
          console.debug(error)
          vm.$snotify.error(error.message)
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            if (error.response.data.code == 200) {
              vm.$snotify.success(error.response.data.message)
            } else {
              vm.$snotify.error(error.response.data.message)
            }
          }
        })
    },
    editOrSave() {
      if (this.selectedProd.id) {
        this.editAgent()
      }
    },
    editAgent() {
      var vm = this
      vm.searching = true
      vm.$API
        .Request('post', `agents/edit`, vm.selectedProd)
        .then(() => {
          vm.$snotify.success('Tarefa atualizada')
          vm.dialog = false
          vm.searching = false
        })
        .catch(error => {
          vm.searching = false
          console.debug(error)
          vm.$snotify.error(error.message)
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            if (error.response.data.code == 200) {
              vm.$snotify.success(error.response.data.message)
            } else {
              vm.$snotify.error(error.response.data.message)
            }
          }
        })
    },
    newAgent() {
      var vm = this
      vm.searching = true
      vm.$API
        .Request('post', `agents/new`, vm.selectedProd)
        .then(() => {
          vm.$snotify.success('Tarefa criada com sucess')
          vm.dialog = false
          vm.fetchSearch()
        })
        .catch(error => {
          vm.searching = false
          console.debug(error)
          vm.$snotify.error(error.message)
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            if (error.response.data.code == 200) {
              vm.$snotify.success(error.response.data.message)
            } else {
              vm.$snotify.error(error.response.data.message)
            }
          }
        })
    },
    openItem(_i) {
      var vm = this
      vm.selectedProd = _i
      vm.dialog = true
    }
  }
}
</script>
